import { api } from "@/lib/api";

/** Herramientas para entrar con huella o cara (passkeys / WebAuthn). */

const toBytes = (s) => {
  const b64 = s.replace(/-/g, "+").replace(/_/g, "/");
  const pad = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
  return Uint8Array.from(atob(pad), (c) => c.charCodeAt(0));
};

const toB64 = (buf) => {
  const bytes = new Uint8Array(buf);
  let str = "";
  bytes.forEach((b) => { str += String.fromCharCode(b); });
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
};

const creation = (o) => ({
  ...o,
  challenge: toBytes(o.challenge),
  user: { ...o.user, id: toBytes(o.user.id) },
  excludeCredentials: (o.excludeCredentials || []).map((x) => ({ ...x, id: toBytes(x.id) })),
});

const request = (o) => ({
  ...o,
  challenge: toBytes(o.challenge),
  allowCredentials: (o.allowCredentials || []).map((x) => ({ ...x, id: toBytes(x.id) })),
});

const asJson = (c, isRegistration) => {
  const r = c.response;
  const out = { id: c.id, rawId: toB64(c.rawId), type: c.type,
                authenticatorAttachment: c.authenticatorAttachment || "", response: {} };
  if (isRegistration) {
    out.response.attestationObject = toB64(r.attestationObject);
    out.response.clientDataJSON = toB64(r.clientDataJSON);
  } else {
    out.response.authenticatorData = toB64(r.authenticatorData);
    out.response.clientDataJSON = toB64(r.clientDataJSON);
    out.response.signature = toB64(r.signature);
    if (r.userHandle) out.response.userHandle = toB64(r.userHandle);
  }
  return out;
};

export const passkeysSupported = () =>
  typeof window !== "undefined" && !!window.PublicKeyCredential;

/** Registra este teléfono o computadora (requiere estar dentro del panel). */
export const registerPasskey = async (label = "") => {
  if (!passkeysSupported()) throw new Error("Este navegador no admite huella ni cara");
  const { data: options } = await api.post("/admin/passkeys/register/options");
  const credential = await navigator.credentials.create({ publicKey: creation(options) });
  await api.post("/admin/passkeys/register/finish",
                 { credential: asJson(credential, true), label });
};

/** Entra al panel con la huella o la cara, sin teclear el código. */
export const loginWithPasskey = async () => {
  if (!passkeysSupported()) throw new Error("Este navegador no admite huella ni cara");
  const { data: options } = await api.post("/admin/passkeys/login/options");
  const credential = await navigator.credentials.get({ publicKey: request(options) });
  const { data } = await api.post("/admin/passkeys/login/finish",
                                  { credential: asJson(credential, false) });
  return data;
};

export const listPasskeys = async () => (await api.get("/admin/passkeys")).data;

export const revokePasskey = (credentialId) =>
  api.delete(`/admin/passkeys/${encodeURIComponent(credentialId)}`);

/** Mensaje claro cuando la persona cancela el lector o se agota el tiempo. */
export const passkeyError = (e, fallback = "No se pudo usar la huella") => {
  if (e?.name === "NotAllowedError") return "Se canceló el lector de huella o caducó el tiempo";
  if (e?.name === "InvalidStateError") return "Este dispositivo ya está registrado";
  return e?.response?.data?.detail || e?.message || fallback;
};
